import React from 'react';
import { Route, IndexRoute } from 'react-router';
import buyPointsRoutes from './pages/buyPoints/buyPointsRoutes';
import Points from './points';
import statementBuyPointsRoutes from './pages/statementBuyPoints/statementBuyPointsRoutes';
import userEarnedPointsRoutes from './pages/userEarnedPoints/userEarnedPointsRoutes';
import transferRequestsRoutes from './pages/transferRequests/transferRequestsRoutes';
import buyActionsRoutes from './pages/buyActions/buyActionsRoutes';
import extract from './pages/extract/extractRoutes';

export default (
  <Route path="points">
    <IndexRoute component={(props) => <Points {...props} />} />
    {buyPointsRoutes}
    {statementBuyPointsRoutes}
    {userEarnedPointsRoutes}
    {buyActionsRoutes}
    {transferRequestsRoutes}
    {extract}
  </Route>
);
